import { Currency } from '@/constants';

const createBlackListKey = (currency: Currency) => `${currency}_bl`;

export const getBlackList = (currency: Currency) => {
  const key = createBlackListKey(currency);

  return new Set<string>(JSON.parse(sessionStorage.getItem(key) ?? '[]'));
};

export const addToBlackList = (currency: Currency, orderId: string) => {
  const blackList = getBlackList(currency);

  blackList.add(orderId);

  sessionStorage.setItem(createBlackListKey(currency), JSON.stringify([...blackList]));
};

export const cleanBlacklist = (currency: Currency, orderIds: string[]) => {
  const blackList = getBlackList(currency);

  if (blackList.size === 0) {
    return;
  }

  const aliveIds = new Set(orderIds);

  blackList.forEach((value) => {
    if (!aliveIds.has(value)) {
      blackList.delete(value);
    }
  });
};

export const filterByBlackList = <TOrder extends { id: string }>(currency: Currency, items: TOrder[]) => {
  const blackList = getBlackList(currency);

  return items.filter(({ id }) => !blackList.has(id));
};
